import { EntityEnums } from "../enums";

export const partitivityDict = [
  {
    value: EntityEnums.Partitivity.Unison,
    label: "unison",
    info: "",
  },
  {
    value: EntityEnums.Partitivity.UnisonOrParts,
    label: "unison or parts",
    info: "",
  },
  {
    value: EntityEnums.Partitivity.UnisonOrDiscreteParts,
    label: "unison or discrete parts",
    info: "",
  },
  {
    value: EntityEnums.Partitivity.Parts,
    label: "parts",
    info: "",
  },
  {
    value: EntityEnums.Partitivity.DiscreteParts,
    label: "discrete parts",
    info: "",
  },
];
